import { useFormState, useWatch } from "react-hook-form";

import { BookingFormMode } from "./booking_form.types";
import { getDirtyBookingsIndexes } from "./booking_form.utils";
import { BookingFormValues } from "./booking_form_values.types";
import { useArePhasesRequired } from "./phases_selector/use_are_phases_required";

export const useAreBookingPhasesValid = (mode: BookingFormMode): boolean => {
  const bookings = useWatch<BookingFormValues, "bookings">({
    name: "bookings"
  });
  const arePhasesRequired = useArePhasesRequired();
  const { dirtyFields } = useFormState<BookingFormValues>();

  if (!arePhasesRequired) {
    return true;
  }

  const bookingsToValidate =
    mode === BookingFormMode.EditAll
      ? getDirtyBookingsIndexes(dirtyFields).map((index) => (bookings ?? [])[index])
      : (bookings ?? []);

  return bookingsToValidate.every((booking) => !!booking?.phaseSourceId);
};
